import React, { Fragment } from "react";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { AxisDateWithDay } from "../util/AxisDateTime";
import { ErrorCheckMark, SuccessCheckMark } from "./AxisCheckMark";

const UserPersonalDetails = ({ user, onSelectProfessionalRole }) => {
  const professionalRoles = [
    { label: "Registered Nurse", active: user?.rn },
    { label: "Registered Midwife", active: user?.rm },
    { label: "Registered Mental Health Nurse", active: user?.rmn },
    { label: "Learning Disabilities Nurse", active: user?.rnld },
    { label: "Health Care Band 2", active: user?.hca2 },
    { label: "Health Care Band 3", active: user?.hca3 },
    { label: "Registered Sick Children's Nurse", active: user?.rscn },
    { label: "Locum Doctor", active: user?.ldoc },
    { label: "Locum Consultant", active: user?.lcon },
    { label: "Support worker", active: user?.supportWorker },
    { label: "Radiographer", active: user?.radiographer },
    { label: "Physiotherapist", active: user?.physiotherapist },
    { label: "Lab assistant", active: user?.labAssistant },
    { label: "Bio-medical scientist", active: user?.bioMedicalScientist },
    { label: "Speech therapist", active: user?.speechTherapist },
    { label: "Occupational therapist", active: user?.occupationalTherapist },
    { label: "Pharmacist", active: user?.pharmacist },
  ].filter((role) => role.active);

  return (
    <Fragment>
      <div>
        <h3>1. Personal Details</h3>
        <Table striped bordered hover>
          <tbody>
            <tr>
              <td className={"tdw-50"}>First Name</td>
              <td>{user?.forename}</td>
            </tr>

            <tr>
              <td>Last Name</td>
              <td>{user?.surname}</td>
            </tr>

            <tr>
              <td>Staff No.</td>
              <td>{user?.staffNumber}</td>
            </tr>

            <tr>
              <td>Telephone</td>
              <td>{user?.telephone}</td>
            </tr>

            <tr>
              <td>Email</td>
              <td>
                <a
                  className={"text-axis-link text-decoration-none"}
                  href={"mailto:" + user?.email}
                >
                  {user?.email}
                </a>
              </td>
            </tr>

            <tr>
              <td>Axis Start Date</td>
              <td>{AxisDateWithDay(user?.startDate)}</td>
            </tr>
          </tbody>
        </Table>

        <h3>2. Medical Role</h3>
        <Table striped bordered hover>
          <tbody>
            {professionalRoles.length > 0 ? (
              professionalRoles.map((role) => (
                <tr key={role.label}>
                  <td className={"tdw-50"}>{role.label}</td>
                  <td>{SuccessCheckMark()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2}>
                  <Button
                    variant="warning"
                    size="sm"
                    className="rounded-pill"
                    onClick={onSelectProfessionalRole}
                  >
                    {ErrorCheckMark()} Select medical role
                  </Button>
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <h3>3. Additional Profile Information</h3>
        <Table striped bordered hover>
          <tbody>
            <tr>
              <td className={"tdw-50"}>Experience Level</td>
              <td>{user?.experience || 'Not specified'}</td>
            </tr>

            <tr>
              <td>Can Work in UK</td>
              <td>{user?.canWorkInUk || 'Not specified'}</td>
            </tr>

            <tr>
              <td>National Insurance Number</td>
              <td>{user?.nationalInsuranceNumber || 'Not provided'}</td>
            </tr>

            <tr>
              <td>About Yourself</td>
              <td style={{whiteSpace: 'pre-wrap'}}>{user?.aboutYourself || 'No description provided'}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default UserPersonalDetails;
